import React, { ReactNode } from 'react';
import { TabsProvider } from './TabsContext';
import styles from './Tabs.module.scss';

interface TabsProps {
  defaultValue: string;
  children: ReactNode;
}

const Tabs = ({ defaultValue, children }: TabsProps) => {
  return (
    <div className={styles.tabsContainer}>
      <TabsProvider defaultValue={defaultValue}>{children}</TabsProvider>
    </div>
  );
};

export default Tabs;
